import Vue from "vue";

Vue.filter( "normalizeNumber", function( value, digit = 0 ) {
	if ( typeof value === "string" ) {
		return value;
	}
	if ( !value ) {
		value = 0;
	}
	return parseFloat( value ).toFixed( digit );
} );



// WEBPACK FOOTER //
// ./src/filters/number.js